var handle = collection?.handle;
var title = collection?.title;
var urlList = {
  productList: "api/v1/collection",
  recommend: "api/v1/collection/recommend",
  meta: "web.MetaWebService/SearchMetaWeb",
};
// 分类列表
const collectionList = new Vue({
  data: () => {
    return {
      listData: [],
      nodata: false,
      productIdList: [],
      recommendList: [],
      filterList: [],
      selectFilterList: [],
      translateObj: {},
      selectParams: { options: [] },
      handle: "",
      collectionTitle: "",
      sectionId: "",
      page: 1,
      size: 60,
      total: 0,
      isFreeShipping: false,
      similarSwiper: "",
      sortList: [
        {
          label: "Comprehensive",
          value: 0,
        },
        {
          label: "Price Low to High",
          value: 4,
        },
        {
          label: "Price High to Low",
          value: 5,
        },
        {
          label: "New",
          value: 2,
        },
        {
          label: "Best Sellers",
          value: 3,
        },
      ],
      excludeField: ["min_price", "max_price"],
      options: [],
      showSortFlag: false,
      activeIndex: 0,
      variantList: {},
      minValue: 0,
      maxValue: 0,
      currencyCode: "USD",
      currencySymbol: "$",
      language: "en",
      isLoading: true,
      loginFlag: false,
      inputValue: 1,
      recommendActiveIndex: -1,

      flashFlag: false,
      timerInterval: null,
      countdownData: { hours: "00", minutes: "00", seconds: "00" },
      metaData: {},
      up: [],
      freeShippingCollections: [
        "straw-bag",
        "jewelry-packaging",
        "jewelry-boxes",
        "sunglasses",
        "watches",
        "hair-claws",
        "chunky-hair-accessories",
        "dress",
        "swimwear",
        "makeup-bags",
        "jewelry-packaging-display",
      ],
      freeShippingFlag: false,
    };
  },
  created() {
    this.handle = handle;
    this.collectionTitle = title;
    const jsonString = theme.getCookies("userSelected");
    const userSelected = theme.inspectJson(jsonString);
    this.currencyCode = userSelected?.currency_code ?? "USD";
    this.language = userSelected?.language ?? "en";
    this.currencySymbol = decodeURIComponent(
      userSelected?.currency_symbol ?? "US$"
    );
    // const userEle = document.querySelector(".hmuser");
    // const email = userEle ? userEle.dataset.email : "";
    // !!email ? (this.loginFlag = true) : (this.loginFlag = false);
    this.loginFlag = theme.isLogin();
    // 获取上一个页面的URL
    const referrer = document.referrer;
    const isFromPromotion =
      referrer && referrer.indexOf("pages/promotion") !== -1;
    this.freeShippingFlag =
      isFromPromotion && this.freeShippingCollections.includes(handle);
    // this.flashFlag = this.flashCollections.includes(handle);
    this.getRecommendList();
    const params = theme.getAllUrlParameters();
    this.handle = params.handle ?? handle;
    this.collectionTitle = params.title ?? title;
    if (params.sort) {
      this.activeIndex = this.sortList.findIndex(
        (item) => item.value == params.sort
      );
    }
    this.up = params.up?.split(",") ?? [];
    this.getProductList("init");
  },
  mounted() {
    // if (this.flashFlag) this.startCountdown();
    // this.similarSwiper = new Swiper(".similar-list", {
    //   slidesPerView: 3,
    //   spaceBetween: 10,
    //   navigation: {
    //     nextEl: ".similar-next",
    //     prevEl: ".similar-prev",
    //   },
    // });
  },
  watch: {
    isLoading(newValue) {
      const skeletonListEle = document.querySelector("#skeleton-collection");
      const newListEle = document.querySelector("#new-collection");
      if (!!newValue) {
        skeletonListEle?.classList.remove("hidden");
        newListEle?.classList.add("hidden");
      } else {
        skeletonListEle?.classList.add("hidden");
        newListEle?.classList.remove("hidden");
      }
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.size);
    },
    // 是否显示左省略号
    showLeftEllipsis() {
      return this.totalPages > 7 && this.page > 4;
    },
    // 是否显示右省略号
    showRightEllipsis() {
      return this.totalPages > 7 && this.page < this.totalPages - 3;
    },
    // 中间显示的页码
    middlePages() {
      const pages = [];
      if (this.totalPages <= 7) {
        // 总页数小于等于7，显示所有页码
        for (let i = 2; i < this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        let start, end;

        if (this.page <= 4) {
          // 当前页靠近开始
          start = 2;
          end = 7;
        } else if (this.page >= this.totalPages - 3) {
          // 当前页靠近结束
          start = this.totalPages - 6;
          end = this.totalPages - 1;
        } else {
          // 当前页在中间
          start = this.page - 2;
          end = this.page + 2;
        }

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
      }
      return pages;
    },
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  methods: {
    // 返回pathName
    getPathName() {
      const url = new URL(window.location.href);
      return url.origin + url.pathname;
    },
    // 获取产品列表
    getProductList(type) {
      if (type !== "init") {
        theme.removeUrlParameters(["up", "sort"]);
        this.up = [];
      }
      const url = `${urlList.productList}?lang=${this.language}&handle=${this.handle}`;
      const param = {
        page: this.page,
        size: this.size,
        sort: this.sortList[this.activeIndex].value,
        free_shipping: this.isFreeShipping,
        ...this.selectParams,
      };
      if (this.selectParams?.options?.length == 0) {
        delete param.options;
      }
      if (!this.isFreeShipping) delete param.isFreeShipping;
      if (this.up.length > 0) param.up = this.up;
      this.listData = [];
      this.isLoading = true;
      // 页面回到顶部
      this.scrollToTop();
      fetchRequest(url, "POST", param)
        .then((response) => {
          this.isLoading = false;
          if (!response.error) {
            this.listData = response.data?.products;
            this.productIdList = [];
            this.listData?.forEach((item) => {
              this.productIdList.push(item.id);
              const count = this.addCartCount(item.id);
              item.cartCount = count;
              item.variant_images = item.variant_images?.map((src) => ({
                src,
                active: false,
              }));
            });
            const filter = response.data?.filter;
            this.filterList = this.handleFilterOptions(filter);
            this.minValue = theme.convertCurrency(
              filter?.min_price,
              "usdToSet",
              true
            );
            this.maxValue = theme.convertCurrency(
              filter?.max_price,
              "usdToSet",
              true
            );
            this.translateObj = response.data?.translate;
            const total = response.data?.total;
            this.total = total > 10000 ? 10000 : total;
            this.nodata = this.total == 0 ? true : false;
            this.metaData = response.data?.meta;
            this.initOption();
          } else {
            this.nodata = true;
          }
        })
        .finally(() => {
          this.initSwipers();
        });
    },
    getRecommendList() {
      fetchRequest(urlList.recommend, "GET", {
        handle: this.handle,
      }).then((response) => {
        if (!response.error) {
          this.recommendList = response.data?.recommend_collections;
          this.initRecommend();
        }
      });
    },
    initRecommend() {
      this.recommendList.map((item, index) => {
        if (item.title == this.collectionTitle) {
          this.recommendActiveIndex = index;
          this.selectFilterList.push({
            label: item.title,
            active: true,
          });
        }
      });
    },
    initOption() {
      for (let item of this.filterList) {
        for (let child of item.children) {
          this.selectFilterList.map((option) => {
            if (option.label == child.label && option.title == child.title) {
              item.showFlag = true;
              child.active = true;
            }
          });
        }
      }
    },
    showWish(id) {
      const jsonString = localStorage.getItem("wishList");
      const userSelected = theme.inspectJson(jsonString);
      const wishList = userSelected
        ? JSON.parse(localStorage.getItem("wishList"))
        : [];
      if (wishList.includes(id)) {
        $('.wishlist[data-id="' + id + '"] .no-wish').hide();
        $('.wishlist[data-id="' + id + '"]')
          .removeClass("addto-wishlist")
          .addClass("cancel-wishlist")
          .find("span")
          .text(theme.wlAvailable);
        $('.wishlist[data-id="' + id + '"] .at')
          .removeClass("at-circle-notch-r at-spin")
          .show();
      }
    },
    /** 处理原始数据 */
    handleFilterOptions(res) {
      let result = [];
      const { excludeField } = this;
      for (let item in res) {
        if (!excludeField.includes(item)) {
          if (Object.prototype.toString.call(res[item]) === "[object Object]") {
            result.push(...this.handleFilterOptions(res[item]));
          } else {
            const name = item.replace(/_/g, " ");
            result.push({
              title: item,
              name: name,
              showFlag: false,
              showMore: false,
              children: (res[item] ?? []).map((list) => ({
                label: list,
                active: false,
                title: item,
              })),
            });
          }
        }
      }
      return result;
    },
    // 返回产品url
    productUrl(item) {
      return `/products/${item?.handle}`;
    },
    // 获取不同类型的id
    getIdStr(name, id) {
      return `${name}-${this.sectionId}-${id}`;
    },

    // 跳转详情页
    goToDetail(item) {
      let url = `${this.productUrl(item)}`;
      // if (this.flashFlag) {
      //   url = `${url}?flash=true`;
      // }
      window.open(url, "_blank");
    },

    /** 产品日期与当前日期相差七天内为true */
    newFlag(date) {
      if (!date) return false;
      const dateStr = date.split(" ")[0];
      const currentDate = new Date();
      const knownDate = new Date(dateStr);
      const timeDiff = currentDate.getTime() - knownDate.getTime();
      const dayDiff = timeDiff / (1000 * 3600 * 24);
      return Math.abs(dayDiff) <= 7;
    },
    // 添加到购物车的数量
    addCartCount(id) {
      const cartList = JSON.parse(localStorage.getItem("cartList")) || [];
      if (cartList.length == 0) return 0;
      let count = 0;
      cartList.forEach((item) => {
        if (item.product_id == id) {
          count += item.quantity;
        }
      });
      return count;
    },
    // 修改产品主图显示
    changeFeaturedImg(variant, item) {
      item.featured_image = variant.src;
      variant.active = true;
    },
    leaveImg(variant) {
      variant.active = false;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
      });
    },
    formatPrice(item) {
      if (item.max_price == item.min_price) {
        return `${theme.formatPrice(
          theme.convertCurrency(item.max_price, "usdToSet")
        )}`;
      } else {
        return `${theme.formatPrice(
          theme.convertCurrency(item.min_price, "usdToSet")
        )} - ${theme.formatPrice(
          theme.convertCurrency(item.max_price, "usdToSet"),
          false
        )}`;
      }
    },
    // 计算折扣
    discount(item) {
      let percent = 0;
      if (
        item.min_compare_at_price !== item.min_price &&
        item.max_compare_at_price > 0 &&
        item.min_compare_at_price > 0
      ) {
        percent = theme.multiply(
          (item.min_compare_at_price - item.min_price) /
            item.min_compare_at_price,
          100
        );
      }
      return percent;
    },

    discountText(item) {
      const percent = this.discount(item);
      return `-${parseInt(percent)}%`;
    },
    initSwipers() {
      const swiperContainers = document.querySelectorAll(".swiper-container");
      swiperContainers.forEach((container) => {
        new Swiper(container, {
          direction: "vertical",
          loop: true,
          autoplay: true,
          delay: 1000,
        });
      });
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.inputValue = this.page;
        this.getProductList();
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.inputValue = this.page;
        this.getProductList();
      }
    },
    goToPage(pageNumber) {
      let number = Number(pageNumber);
      if (number > this.totalPages) {
        number = this.totalPages;
      }
      if (number < 1) {
        number = 1;
      }
      this.inputValue = number;
      this.page = number;
      this.getProductList();
    },
    async getEndTime() {
      const params = {
        group: "flash",
        marketing: "web",
      };
      const response = await fetchConnect(urlList.meta, "POST", params);
      if (!response.error && response.data.items) {
        const flashData = response.data?.items.find(
          (item) => item.field === "flash"
        );
        return flashData;
      }
      return null;
    },
    async startCountdown() {
      let flashData = await this.getEndTime();
      if (!flashData) return;
      let count = 0;
      const time = theme.formatDateTime(flashData.flashEndTime);
      this.countdownData = theme.countdown(time, false);
      const updateTimer = async () => {
        if (
          this.countdownData.hours == 0 &&
          this.countdownData.seconds == 0 &&
          this.countdownData.minutes == 0 &&
          count < 1
        ) {
          count++;
          flashData = await this.getEndTime();
        }
        const newTime = theme.formatDateTime(flashData.flashEndTime);
        this.countdownData = theme.countdown(newTime, false);
      };

      // 启动定时器
      const interval = setInterval(updateTimer, 1000);
      updateTimer(); // 立即执行一次

      // 返回清理函数
      return () => clearInterval(interval);
    },
  },
  template: `<div class="new-collection-list">
    <div class="grid grid--5-col-desktop product-list" v-if="!nodata">
      <div class="grid-item" v-for="item in listData">
        <div class="relative" @click="goToDetail(item)">
          <div class="basic-image">
            <img class="default-img" :src="item.featured_image + '?width=370'">
            <img class="hover-img" :src="item.featured_image2 + '?width=370'">
          </div>
        </div>
        <div class="relative">
          <div class="page_countmain" v-if="flashFlag">
            <div class="product_timer flex justify-space-between">
              <div class="timer-title">Up to 17% Off</div>
              <div
                class="wbmultipro_countd countd_all"
              >
                <span>Ends In</span>
                <span class="count wb_chours">{{ countdownData.hours }}</span><span> : </span><span class="count wb_cminutes">{{ countdownData.minutes }}</span
                ><span> : </span><span class="count wb_cseconds">{{ countdownData.seconds }}</span>
              </div>
            </div>
          </div>
          <wb-card-variant>
            <div class="wbproductdes">
              <product-info :id="getIdStr('ProductInfo',item.id)" :data-section-input="sectionId" :data-section="sectionId" data-layout="card" :data-url="productUrl(item)">
                <div class="card__information">

                  <div class="flex" v-if="item.free_shipping || freeShippingFlag">
                    <span class="free-shipping">
                    free shipping
                    </span>
                  </div>
                  <h2 class="cardhide_toggle card__heading overflow_text h5" :id="getIdStr('title',item.id)">
                    <div @click="goToDetail(item)" :id="getIdStr('CardLink',item.id)" class="full-unstyled-link">
                      <span class="new-font-tag" v-if="newFlag(item.published_at)">NEW</span>{{ item.title}}
                    </div>
                  </h2>
                  <div class="card-information">
                    <div class="no-js-hidden wbhprice" :id="getIdStr('price',item.id)" role="status">
                      <div class="card_product_Price">
                        <span class="card_sale_price notranslate">
                          {{ formatPrice(item) }}
                        </span>
                        <span class="discount-tag" v-if="discount(item) > 0">{{ discountText(item) }}</span>
                      </div>
                    </div>
                    <div class="flex" v-if="loginFlag && (item.sold>0 || item.score>0)" style="max-height: 15px; overflow:hidden;">
                      <div class="swiper-container">
                        <div class="swiper-wrapper">
                          <div v-if="item.sold>0" class="product-sold swiper-slide">
                            {{ item.sold > 1000 ? (item.sold / 1000).toFixed(1) + 'K+' : item.sold }} sold recently
                          </div>

                          <div class="swiper-slide review-rate flex align-items-center margin-left-5" v-if="item.score>0">
                            <div class="rate-item" v-for="rate in 5" :class="rate<=item.score ? 'rate-item-active' : ''">
                              <i class="base-icon">
                                <svg viewBox="0 0 512 512">
                                  <path
                                    d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"
                                  ></path>
                                </svg>
                              </i>
                            </div>
                            <div class="rate-count margin-left-5">
                              ({{ item.score_count }})
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="flex" v-if="!loginFlag">
                      <div class="guide-login cardhide_toggle">
                        <span>Sold:</span>
                        <a href="/account/register">Login>></a>
                      </div>
                      <div class="review-rate flex align-items-center margin-left-5" v-if="item.score>0">
                        <div class="rate-item" v-for="rate in 5" :class="rate<=item.score ? 'rate-item-active' : ''">
                          <i class="base-icon">
                            <svg viewBox="0 0 512 512">
                              <path
                                d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"
                              ></path>
                            </svg>
                          </i>
                        </div>
                        <div class="rate-count margin-left-5">
                          ({{ item.score_count }})
                        </div>
                      </div>
                    </div>

                    <div class="flex wuyuwuwwd">
                      <div class="flex wb_select_btnaa1 align-items-center">
                        <card-m-varirimg v-for="varir in item.variant_images" @mouseenter="changeFeaturedImg(varir, item)" @mouseleave="leaveImg(varir)">
                          <div class="card-m-varirimg" :class="varir.active ? 'active': ''" data-section="template--18313698181350__hot_product_HbNtUY" :data-product="varir.product_id" :data-featured_media="varir.id">
                            <img :src="varir.src + '?width=66'">
                          </div>
                        </card-m-varirimg>
                        <div v-if="item.variants_count>3" class="color-666">...</div>
                      </div>
                      <div class="flex align-center gap-5">
                        <div class="wb_select_btnaa1">
                          <span class="hidden">{{ showWish(item.id) }}</span>
                          <div class="btn wishlist heratPop addto-wishlist" :data-id="item.id">
                            <i class="at at-heart"></i>
                            <img class="no-wish" src="//www.gooddiy.com/cdn/shop/t/82/assets/no_wish.png" alt="">
                          </div>
                        </div>
                        <div class="wb_select_btnaa1">
                          <modal-opener data-modal="#QuickAdd" class="relative">
                            <button :id="getIdStr('quick-add',item.id)" type="submit" name="add" class="wb_select_btn1 link underlined-link quick-add__submit button--full-width" aria-haspopup="dialog"  :data-product-url="productUrl(item)" :data-product-id="item.id" data-gpo-collection-item-handle="fashion-national-flag-stainless-steel-necklace-dripping-oil-stainless-steel-necklaces-2">
                              <span class="hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                </svg>
                                Select options
                              </span>
                              <div>
                                <img class="cart-img heratPop" src="https://cdn.shopify.com/s/files/1/0574/9807/5287/files/new-shopping-cart-af002be6.png?v=1716603513">
                              </div>
                              <div class="loading-overlay__spinner hidden">
                                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                              </div>
                            </button>
                            <span class="add-cart-count" :class="item.cartCount>0 ? '' : 'hidden'" :data-id="item.id">{{ item.cartCount > 99 ? '99+' : item.cartCount }}</span>
                          </modal-opener>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </product-info>
            </div>
          </wb-card-variant>
        </div>
      </div>
    </div>
    <div class="pagenation justify-content-center flex" v-if="!nodata">
      <div class="pagenation-btn flex align-items-center justify-content-center border-radius-2 cursor-pointer" @click="prevPage" :disabled="page === 1">
        <img class="pagenation-arrow arrow-left" src="https://assets.gooddiy.com/image/arrow_up.png">
      </div>
      <div class="pagenation-item border-radius-2 notranslate" :class="page==1 ? 'active' : ''" @click="goToPage(1)">1</div>
      <div v-if="showLeftEllipsis" class="notranslate">...</div>
      <div class="pagenation-item border-radius-2 notranslate" :class="pageNumber==page? 'active' : ''" v-for="pageNumber in middlePages" :key="pageNumber" @click="goToPage(pageNumber)">{{ pageNumber }}</div>

      <div v-if="showRightEllipsis" class="notranslate">...</div>
      <div v-if="totalPages > 1" class="pagenation-item border-radius-2 notranslate" :class="page==totalPages ? 'active' : ''" @click="goToPage(totalPages)">{{ totalPages }}</div>
      <div class="pagenation-btn flex align-items-center justify-content-center border-radius-2 cursor-pointer" @click="nextPage" :disabled="page === totalPages">
        <img class="pagenation-arrow arrow-right" src="https://assets.gooddiy.com/image/arrow_up.png">
      </div>
      <div class="margin-left-10">
        Total {{ totalPages }} pages, Go To Page
      </div>
      <div class="input-page pagenation-btn border-radius-2 margin-left-10">
        <input type="number" v-model="inputValue"  @keyup.enter="goToPage(inputValue)"/>
      </div>
    </div>
    <div class="flex justify-content-center align-items-center no-data" v-if="nodata">
      <div>
        <img src="https://assets.gooddiy.com/image/no-data.png">
      </div>
    </div>
  </div>`,
});

// 分类上方推荐分类
const collectionCategory = new Vue({
  data: () => {
    return {
      mySwiper: null,
    };
  },
  computed: {
    recommendList: () => collectionList.recommendList,
    recommendActiveIndex: () => collectionList.recommendActiveIndex,
  },
  mounted() {
    // 获取窗口宽度并根据宽度设置slidesPerView;
    this.setSlides();
    // 监听窗口大小变化事件，以便动态调整slidesPerView
    window.addEventListener("resize", this.setSlides);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setSlides);
  },
  methods: {
    setSlides() {
      const screenWidth = screen.width;
      let sliderNum = 14;
      if (screenWidth > 1920) {
        sliderNum = 18;
      } else if (screenWidth > 1200) {
        sliderNum = 14;
      } else if (screenWidth > 1000) {
        sliderNum = 10;
      } else if (screenWidth > 768) {
        sliderNum = 8;
      } else {
        sliderNum = 6;
      }
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-container-rich", {
          slidesPerView: sliderNum,
          spaceBetween: 30,
          navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
          },
          // rtl: true, // 设置为从右到左轮播
        });
      });
    },
    clickUrl(item, index) {
      collectionFilter.clearAll();
      collectionList.activeIndex = 0;
      document.querySelector("#selectedSort").innerHTML =
        collectionList.sortList[0].label;
      if (collectionList.recommendActiveIndex !== index) {
        collectionList.recommendActiveIndex = index;
        collectionList.handle = item.handle;
        collectionList.collectionTitle = item.title;
        collectionList.page = 1;
        theme.addUrlParameters({ handle: item.handle, title: item.title });
        collectionList.selectFilterList.push({
          label: item.title,
          active: true,
        });
        collectionList.getProductList();
      } else {
        collectionList.recommendActiveIndex = -1;
        collectionList.handle = handle;
        collectionList.collectionTitle = title;
        collectionList.page = 1;
        theme.removeUrlParameters(["handle", "title"]);
        const index = collectionList.selectFilterList.findIndex(
          (item) => item.label === item.title
        );
        collectionList.selectFilterList.splice(index, 1);
        collectionList.getProductList();
      }
      // window.location.href = `/collections/${item.handle}`;
    },
    clickSwiperPre() {
      this.mySwiper.slidePrev();
    },
    clickSwiperNext() {
      this.mySwiper.slideNext();
    },
  },
  template: `<div class="rich-box relative" v-show="recommendList.length > 0">
    <div class="swiper-container-rich">
      <div class="swiper-wrapper">
        <div class="underline-on-hover flex_cc swiper-slide" v-for="(item, index) in recommendList" @click="clickUrl(item, index)">
          <div class="viewii" :class="recommendActiveIndex == index ? 'active' : ''">
            <img :src="item.featured_image + '?width=256'" loading="lazy">
          </div>
          <div class="mt5 fs_12_c_6">
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
      <div class="rich-swiper-prev" @click="clickSwiperPre">
        <img class="pagenation-arrow arrow-left" src="https://assets.gooddiy.com/image/arrow_up.png">
      </div>
      <div class="rich-swiper-next"  @click="clickSwiperNext">
        <img class="pagenation-arrow arrow-right" src="https://assets.gooddiy.com/image/arrow_up.png">
      </div>
    </div>
  </div>`,
});

// 分类上方筛选
const collectionTopFilter = new Vue({
  data: () => {
    return {
      showSortFlag: false,
    };
  },
  mounted() {
    window._paq = window._paq || [];
    window._paq.push([
      "setEcommerceView",
      false, //
      false, //
      title, //当前分类名称,或者多个使用数组 ["第一个","第二个等"]
    ]);
    window._paq.push(["trackPageView"]);
  },
  computed: {
    isFreeShipping: () => collectionList.isFreeShipping,
    collectionTitle: () => collectionList.collectionTitle,
    sortList: () => collectionList.sortList,
    filterData: () => collectionList.filterData,
    activeIndex: () => collectionList.activeIndex,
    totalPages: () => collectionList.totalPages,
    totalPages() {
      return Math.ceil(collectionList.total / collectionList.size);
    },
    startNumber() {
      return (collectionList.page - 1) * collectionList.size + 1;
    },
    endNumber() {
      let add = collectionList.size;
      if (collectionList.page === this.totalPages) {
        const remainder = collectionList.total % collectionList.size;
        add = remainder < collectionList.size ? remainder : collectionList.size;
      }
      return (collectionList.page - 1) * collectionList.size + add;
    },
    total() {
      return collectionList.total;
    },
  },
  methods: {
    selectSort(index) {
      this.showSortFlag = false;
      collectionList.activeIndex = index;
      document.querySelector("#selectedSort").innerHTML =
        this.sortList[this.activeIndex].label;
      // showNewCollection();
      collectionList.page = 1;
      collectionList.getProductList();
    },
    // 点击筛选freeShipping
    clickFreeShipping() {
      collectionList.isFreeShipping = !collectionList.isFreeShipping;
      collectionList.page = 1;
      collectionList.getProductList();
    },
  },
  template: `<div class="list-top">
    <p class="title">{{ collectionTitle }} <span class="sub-title">( Items {{ startNumber }} to {{ endNumber}} of {{ total }} Total )</span></p>
    <div class="flex align-items-center gap-10">
      <div class="sort-content" @mouseenter="showSortFlag=true" @mouseleave="showSortFlag=false">
        <div class="flex align-items-center justify-space-between">
          <div>
            <span> Sort By</span>
            <span class="active margin-left-20" id="selectedSort">{{ sortList[activeIndex].label }}</span>
          </div>
          <img class="arrow arrow-dn" v-if="!showSortFlag" src="https://assets.gooddiy.com/image/arrow_dn.png">
          <img class="arrow arrow-up" v-else="showSortFlag" src="https://assets.gooddiy.com/image/arrow_up.png">
        </div>
        <div class="sort-item" v-show="showSortFlag">
          <div class="flex justify-space-between align-items-center" :class="activeIndex==index? 'active' : ''" v-for="(item, index) in sortList" @click="selectSort(index)">
            <span>{{ item.label }}</span>
            <img v-if="activeIndex==index" class="right" src="https://assets.gooddiy.com/image/right.png">
          </div>
        </div>
      </div>
      <div class="cursor-pointer flex align-items-center gap-10" @click="clickFreeShipping">
        <div class="check-box" :class="isFreeShipping ? 'check' : ''"><img src="/cdn/shop/t/66/assets/check.png" alt="" class="coupon-tips"></div>
        <div class="flex">
          <span class="free-shipping">free shipping</span>
        </div>
      </div>
    </div>
  </div>`,
});

// 分类左侧筛选
const collectionFilter = new Vue({
  data: () => {
    return {
      currencyCode: "USD",
      currencySymbol: "US$",
      minPriceInputShow: false,
      maxPriceInputShow: false,
      minPrice: 0,
      maxPrice: 0,
      maxOption: 5,
      timer: null,
    };
  },
  created() {
    this.currencyCode = collectionList.currencyCode;
    this.currencySymbol = collectionList.currencySymbol;
  },

  computed: {
    filterList: () => collectionList.filterList,
    selectFilterList: () => collectionList.selectFilterList,
    options: () => collectionList.options,
    minValue: () => collectionList.minValue,
    maxValue: () => collectionList.maxValue,
    translateObj: () => collectionList.translateObj,
  },
  methods: {
    inputFocus(type) {
      if (type == "min") {
        collectionList.minValue = "";
        this.maxPrice = "";
        this.minPriceInputShow = true;
      } else {
        collectionList.maxValue = "";
        this.maxPrice = "";
        this.maxPriceInputShow = true;
      }
    },
    filterPrice(type) {
      clearTimeout(this.timer);
      if (type == "min") {
        collectionList.minValue = this.minPrice;
      } else {
        collectionList.maxValue = this.maxPrice;
      }

      if (collectionList.minValue === "" || collectionList.maxValue === "")
        return;
      this.timer = setTimeout(() => {
        // if (type == "min") {
        // }
        // if (type == "max") {
        //   if (Number(this.minValue) > Number(this.maxValue)) {
        //   }
        // }
        collectionList.selectParams = {
          ...collectionList.selectParams,
          min_price: theme.convertCurrency(collectionList.minValue, "setToUsd"),
          max_price: theme.convertCurrency(collectionList.maxValue, "setToUsd"),
        };
        // showNewCollection();
        collectionList.page = 1;
        collectionList.getProductList();
      }, 2000);
    },
    // 移除所有的筛选条件
    clearAll(type) {
      for (let item of collectionList.selectFilterList) {
        item.active = false;
      }
      for (let item of collectionList.filterList) {
        item.showFlag = false;
        for (let child of item.children) {
          child.active = false;
        }
      }
      collectionList.selectFilterList = [];
      collectionList.selectParams = { options: [] };
      collectionList.handle = handle;
      collectionList.collectionTitle = title;
      if (type) {
        theme.removeUrlParameters(["handle", "title"]);
        collectionList.recommendActiveIndex = -1;
      }

      collectionList.page = 1;
      collectionList.getProductList();
    },
    // 移除当前选中的筛选条件
    removeOption(item, index) {
      item.active = false;
      collectionList.selectFilterList.splice(index, 1);

      if (!item.title) {
        collectionList.handle = handle;
        collectionList.collectionTitle = title;
        theme.removeUrlParameters(["handle", "title"]);
        collectionList.recommendActiveIndex = -1;
      }
      if (collectionList.options.includes(item.title)) {
        const index = collectionList?.selectParams?.options?.findIndex(
          (item) => item == item.label
        );
        collectionList?.selectParams?.options.splice(index, 1);
      } else {
        delete collectionList.selectParams[item.title];
      }
      collectionList.page = 1;
      collectionList.getProductList();
    },
    // 选择筛选条件
    checkOption(item, options) {
      const preIndex = options.findIndex((data) => data.active);
      item.active = !item.active;
      if (item.active) {
        if (preIndex != -1) {
          const selctIndex = this.selectFilterList.findIndex(
            (data) => data.label === options[preIndex].label
          );
          options[preIndex].active = false;
          this.selectFilterList.splice(selctIndex, 1);
        }
        collectionList.selectFilterList.push(item);

        if (collectionList.options.includes(item.title)) {
          collectionList.selectParams?.options.push(item.label);
        } else {
          collectionList.selectParams = {
            ...collectionList.selectParams,
            [item.title]: item.label,
          };
        }
        collectionList.page = 1;
        collectionList.getProductList();
      } else {
        const index = collectionList.selectFilterList.findIndex(
          (data) => data.label === item.label
        );
        collectionList.selectFilterList.splice(index, 1);
        if (collectionList.options.includes(item.title)) {
          const index = collectionList?.selectParams?.options?.findIndex(
            (item) => item == item.label
          );
          collectionList?.selectParams?.options.splice(index, 1);
        } else {
          delete collectionList.selectParams[item.title];
        }
        collectionList.page = 1;
        collectionList.getProductList();
      }
    },
    // 显示翻译后文字
    showTranslate(label) {
      if (this.translateObj && Object.keys(this.translateObj).length > 0) {
        return this.translateObj[label] ?? label;
      }
      return label;
    },
  },
  template: `<div class="filter-content" v-if="filterList.length>0">
    <div class="select-filter margin-b-20" v-if="selectFilterList.length>0">
      <div class="select-filter-title">
        Filters:
        <span class="cursor-pointer" @click="clearAll('click')">
          <span class="clear-all">Clear all</span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1729151328607" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="10018" width="12" height="12">
              <path d="M954.368 133.256533H656.384C652.9024 59.1872 589.6192 0 512.341333 0c-77.346133 0-140.629333 59.1872-144.042666 133.256533H69.632a34.952533 34.952533 0 0 0-35.498667 34.4064c0 18.978133 15.906133 27.170133 35.498667 27.170134h884.736c19.592533 0 35.498667-8.192 35.498667-27.170134a34.952533 34.952533 0 0 0-35.498667-34.4064z m-355.9424 0H431.3088c4.437333-58.026667 42.871467-77.141333 81.032533-77.141333 38.0928 0 80.6912 19.456 86.084267 77.141333z m243.029333 171.690667V962.56H185.002667V304.9472c0-18.978133-3.618133-34.338133-23.210667-34.338133a34.952533 34.952533 0 0 0-35.498667 34.338133v684.714667c0 18.978133 15.906133 34.338133 35.498667 34.338133H865.621333c19.592533 0 35.498667-15.36 35.498667-34.4064V304.9472a34.952533 34.952533 0 0 0-35.498667-34.338133c-19.592533 0-24.098133 15.36-24.098133 34.338133z m-404.343466 530.8416V389.9392c0-27.716267-8.874667-50.107733-28.4672-50.107733-19.6608 0-27.0336 22.391467-27.0336 50.107733v445.8496c0 27.716267 7.3728 50.176 27.0336 50.176 19.592533 0 28.4672-22.528 28.4672-50.176z m212.5824 0V389.9392c0-27.716267-9.0112-50.107733-28.603734-50.107733s-27.784533 22.391467-27.784533 50.107733v445.8496c0 27.716267 8.192 50.176 27.784533 50.176s28.603733-22.528 28.603734-50.176z" fill="#ed5749" p-id="10019"/>
            </svg>
          </span>
        </span>
      </div>
      <div class="flex flex-wrap align-items-center" style="gap: 8px;">
        <span v-for="(item, index) in selectFilterList" class="select-filter-item cursor-pointer notranslate" @click="removeOption(item,index)">{{ showTranslate(item.label) }} ✕</span>
      </div>
    </div>
    <div class="filter-title flex justify-space-between align-items-center cursor-pointer" @click="item.showFlag=!item.showFlag">
      <span>Price(<span>{{ currencyCode }}</span>)</span>
    </div>
    <div class="price-input flex justify-space-between margin-b-20">
      <div class="flex align-items-center input-border">
        {{ currencySymbol }}
        <input v-if="minPriceInputShow" type="number" v-model="minPrice" @input="filterPrice('min')" @focus="inputFocus('min')">
        <input v-else type="number" v-model="minValue" @focus="inputFocus('min')">
      </div>
        -
      <div class="flex align-items-center input-border">
        {{ currencySymbol }}
        <input v-if="maxPriceInputShow" type="number" v-model="maxPrice" @input="filterPrice('max')" @focus="inputFocus('max')">
        <input v-else type="number" v-model="maxValue" @focus="inputFocus('max')">
      </div>
    </div>

    <div v-for="item in filterList" class="margin-b-20">
      <div class="filter-title flex justify-space-between align-items-center cursor-pointer" v-if="item.children.length" @click="item.showFlag=!item.showFlag">
        <span>{{ item.name }} </span>
        <span>
          <svg v-show="!item.showFlag" width="18" height="18" viewBox="0 0 48 48" fill="none"><path d="M24.0605 10L24.0239 38" stroke="#222" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
          </path><path d="M10 24L38 24" stroke="#222" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          <svg v-show="item.showFlag" width="18" height="18" viewBox="0 0 48 48" fill="none"><path d="M10.5 24L38.5 24" stroke="#222" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </span>
      </div>
      <div class="filter-child-content" v-show="item.showFlag">
        <div v-if="item.title == 'color'" class="filter-color-content flex flex-wrap">
          <div v-for="(child, index) in item.children" :class="child.active ? 'active' : ''" :title="child.label" :style="{backgroundColor: child.label}" class="cursor-pointer filter-color-option" @click="checkOption(child, item.children)">
          </div>
        </div>
        <div v-else v-for="(child, index) in item.children" class="filter-child flex align-items-center justify-space-between cursor-pointer" v-show="item.showMore || index < maxOption" @click="checkOption(child, item.children)">
          <div class="flex align-items-center" style="gap: 10px;">
            <div class="checkbox" :class="child.active ? 'checked' : ''">
              <img src="/cdn/shop/t/66/assets/check.png" alt="">
            </div>
            <div class="ellipsis notranslate" :title="child.label">
              {{ showTranslate(child.label) }}
            </div>
          </div>
          <div v-if="child.active">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1729151328607" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="10018" width="12" height="12">
                <path d="M954.368 133.256533H656.384C652.9024 59.1872 589.6192 0 512.341333 0c-77.346133 0-140.629333 59.1872-144.042666 133.256533H69.632a34.952533 34.952533 0 0 0-35.498667 34.4064c0 18.978133 15.906133 27.170133 35.498667 27.170134h884.736c19.592533 0 35.498667-8.192 35.498667-27.170134a34.952533 34.952533 0 0 0-35.498667-34.4064z m-355.9424 0H431.3088c4.437333-58.026667 42.871467-77.141333 81.032533-77.141333 38.0928 0 80.6912 19.456 86.084267 77.141333z m243.029333 171.690667V962.56H185.002667V304.9472c0-18.978133-3.618133-34.338133-23.210667-34.338133a34.952533 34.952533 0 0 0-35.498667 34.338133v684.714667c0 18.978133 15.906133 34.338133 35.498667 34.338133H865.621333c19.592533 0 35.498667-15.36 35.498667-34.4064V304.9472a34.952533 34.952533 0 0 0-35.498667-34.338133c-19.592533 0-24.098133 15.36-24.098133 34.338133z m-404.343466 530.8416V389.9392c0-27.716267-8.874667-50.107733-28.4672-50.107733-19.6608 0-27.0336 22.391467-27.0336 50.107733v445.8496c0 27.716267 7.3728 50.176 27.0336 50.176 19.592533 0 28.4672-22.528 28.4672-50.176z m212.5824 0V389.9392c0-27.716267-9.0112-50.107733-28.603734-50.107733s-27.784533 22.391467-27.784533 50.107733v445.8496c0 27.716267 8.192 50.176 27.784533 50.176s28.603733-22.528 28.603734-50.176z" fill="#ed5749" p-id="10019"/>
              </svg>
            </span>
          </div>
        </div>
        <div class="cursor-pointer option-view-more" @click="item.showMore=!item.showMore" v-if="!item.showMore && item.children.length > maxOption && item.title != 'color'">
          <svg t="1729155433696" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11359" width="16" height="16"><path d="M916.115386 467.228307 557.971519 467.228307 557.971519 109.085464c0-24.714891-20.056801-44.771693-44.770669-44.771693-24.715915 0-44.772716 20.056801-44.772716 44.771693l0 358.142843L110.285291 467.228307c-24.715915 0-44.771693 20.056801-44.771693 44.771693s20.056801 44.772716 44.771693 44.772716l358.142843 0 0 358.143866c0 24.761963 20.056801 44.770669 44.772716 44.770669 24.713868 0 44.770669-20.008706 44.770669-44.770669L557.971519 556.772716l358.143866 0c24.762987 0 44.771693-20.057825 44.771693-44.772716S940.878372 467.228307 916.115386 467.228307L916.115386 467.228307zM916.115386 467.228307" fill="#ed5749" p-id="11360"></path></svg>
          <span>View More</span>
        </div>
      </div>

    </div>
  </div>`,
});

// // 相关系列
// const relatedCollection = new Vue({
//   data: () => {
//     return {};
//   },
//   computed: {
//     metaData: () => collectionList.metaData,
//   },
//   methods: {},
//   template: `
//   <div>
//     <div class="bg-white page-width related-content border-radius-8" v-if="metaData?.related && metaData?.related.length > 0">
//       <div class="title">Related Searches</div>
//       <div class="flex gap-10 related-items">
//         <a class="related-item" v-for="item in metaData?.related" :href="'/collections/'+item.handle">{{ item.name }}</a>
//       </div>
//     </div>
//     <div v-if="metaData?.description" class="bg-white page-width description-content border-radius-8" v-html="metaData?.description">
//     </div>
//   </div>
//   `,
// });
// relatedCollection.$mount("#collection-bottom");

// 实例挂载
collectionList.$mount("#new-collection-list");
collectionCategory.$mount("#category-rich");
collectionFilter.$mount("#left-filter");
collectionTopFilter.$mount("#top-filter");
